import React from 'react'
import { generatePath, NavLink, useParams } from 'react-router-dom'

import ShopForm from '@components/shop/ShopForm'
import ShopTopMenu from '@components/shop/ShopTopMenu'
import { Nav, Navbar } from 'rsuite'
import { AddOutline } from 'react-ionicons'
import { ROUTE_SHOPS_CREATE_SHOP } from '@@partner:config/routes'

export default function EditShopPage () {
  const { shopId, brandSlug } = useParams<any>()

  return (
    <div className="MakeOrderPage">
      { shopId ? (
        <h1 className="u-heading">Редактирование магазина #{shopId}</h1>
      ) : (
        <h1 className="u-heading">Создание магазина</h1>
      )}
      <ShopTopMenu />
      <Navbar appearance='subtle'>
        <Nav>
          <Nav.Item
            icon={<AddOutline />}
            as={NavLink}
            to={generatePath(ROUTE_SHOPS_CREATE_SHOP, {
              brandSlug
            })}
          >
              Добавить магазин
          </Nav.Item>
        </Nav>
      </Navbar>
      <ShopForm shopId={shopId} brandSlug={brandSlug} />
    </div>
  )
}
